import {createReducer} from "redux-act";
import * as actions from "modules/actions";
import {IUser} from "modules/types";
import {RequestState} from "modules/enums";
import {ILoginAppPayload} from "modules/actions";
import {SECRET_KEY_NAME} from "modules/constants";

interface IUserReducer {
	isUserChecked: boolean;
	isUserLogged: boolean;
	isAdditionalDataRequired: boolean;
	ssoParams?: URLSearchParams;
	ssoCode?: string;
	ssoApp?: ILoginAppPayload;
	user?: IUser;
	requestState: RequestState;
	error: string | null;
}

const defaultState: IUserReducer = {
	isUserChecked: false,
	isUserLogged: false,
	isAdditionalDataRequired: false,
	requestState: RequestState.IDLE,
	error: null,
};

const onUserChecked = (state: IUserReducer) => ({
	...state,
	isUserChecked: true,
});

const onUserRequest = (state: IUserReducer) => ({
	...state,
	requestState: RequestState.Requested,
});

const onUserReceived = (state: IUserReducer, payload: IUser): IUserReducer => ({
	...state,
	user: payload,
	isUserLogged: true,
	isAdditionalDataRequired: false,
	ssoCode: undefined,
	ssoApp: undefined,
	requestState: RequestState.Received,
});

const onError = (state: IUserReducer, error: string): IUserReducer => ({
	...state,
	requestState: RequestState.Error,
	error,
});

const onUserClear = (state: IUserReducer) => {
	localStorage.removeItem(SECRET_KEY_NAME);
	return {
		...state,
		user: undefined,
		isUserLogged: false,
	};
};

const onUserDataRequired = (state: IUserReducer, code: string) => ({
	...state,
	isAdditionalDataRequired: true,
	ssoCode: code,
});

const onUserDataRequiredApp = (state: IUserReducer, app: ILoginAppPayload) => ({
	...state,
	isAdditionalDataRequired: true,
	ssoApp: app,
});

const onUserSetSSOParams = (state: IUserReducer, params: URLSearchParams) => ({
	...state,
	ssoParams: params,
});

export const user = createReducer<IUserReducer>({}, defaultState)
	.on(actions.userChecked, onUserChecked)
	.on(actions.userFetch, onUserRequest)
	.on(actions.userFetchSuccess, onUserReceived)
	.on(actions.userFetchFailed, onError)
	.on(actions.userRegister, onUserRequest)
	.on(actions.userRegisterApp, onUserRequest)
	.on(actions.userRegisterSuccess, onUserReceived)
	.on(actions.userRegisterFailed, onError)
	.on(actions.userLogin, onUserRequest)
	.on(actions.userLoginApp, onUserRequest)
	.on(actions.userLoginSuccess, onUserReceived)
	.on(actions.userLoginFailed, onError)
	.on(actions.userUpdate, onUserRequest)
	.on(actions.userUpdateSuccess, onUserReceived)
	.on(actions.userUpdateFailed, onError)
	.on(actions.userLogout, onUserClear)
	.on(actions.userAskForRegistration, onUserDataRequired)
	.on(actions.userAskForRegistrationApp, onUserDataRequiredApp)
	.on(actions.userSetSSOParams, onUserSetSSOParams);
